import { CustomColumnDef, TableCellProps, WbColumnWidthType } from '../types';
import {
  getColumnId,
  parseColumnAutoMinMaxWidth,
  parseColumnMaxWidth,
  parseColumnMinWidth,
  parseColumnWidth,
} from './utils';

export function adaptToTanstackColumn<T>(column: TableCellProps<T>) {
  let maxSize = parseColumnMaxWidth(column.maxWidth);
  let minSize = parseColumnMinWidth(column.minWidth);

  const width = parseColumnWidth(column.width);

  // adjust min and max width if they conflict with a fixed width
  if (width.type === WbColumnWidthType.FIXED) {
    if (width.value < minSize) minSize = width.value;
    if (width.value > maxSize) maxSize = width.value;
  }

  const colId = getColumnId(column);

  const resizable = column.resizable ?? true;

  const tanstackColumn: CustomColumnDef<T> = {
    id: colId,
    accessorKey: column.field,
    header: () => column.headerName,
    footer: (props: any) => props.column.id,
    enableResizing: resizable,
    enableSorting: column?.sortable,
    maxSize: maxSize,
    minSize: minSize,
    originalWidth: column.width,
    parsedWidth: width,
    parsedMinWidth: minSize,
    parsedMaxWidth: maxSize,
    parsedAutoMaxWidth: parseColumnAutoMinMaxWidth(column.autoMaxWidth),
    parsedAutoMinWidth: parseColumnAutoMinMaxWidth(column.autoMinWidth),
  };

  return tanstackColumn;
}
